module.exports = __webpack_public_path__ + "img/reference-gsimedia.6a80db36.webp";